import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Single Firebase app instance for the whole client. `initializeApp` throws if
// called twice, so every consumer (recipes API, remote-update listener, ...)
// must import `app`/`db` from here rather than initializing their own.
const firebaseConfig = {
  apiKey: "AIzaSyB-GjLjhDtTCyXce48RTIzLsfWqD63o5Rg",
  authDomain: "recipes-b0caf.firebaseapp.com",
  projectId: "recipes-b0caf",
  storageBucket: "recipes-b0caf.appspot.com",
  messagingSenderId: "925632164527",
  appId: "1:925632164527:web:3bebb08879cb726fb41a5a",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// The kiosk remote-update control plane (the app_config collection) lives in a
// SEPARATE Firebase project from the recipes data above. Initialized as a named
// app so it coexists with the default app.
const appConfigFirebaseConfig = {
  apiKey: "AIzaSyD1BIg4cJsXDw0ySDGmu7tLMTlhRRIeeGg",
  authDomain: "kiosk-management-422bc.firebaseapp.com",
  projectId: "kiosk-management-422bc",
  storageBucket: "kiosk-management-422bc.firebasestorage.app",
  messagingSenderId: "230530899409",
  appId: "1:230530899409:web:241021c24bdbe23bae94f0",
};

export const appConfigApp = initializeApp(appConfigFirebaseConfig, "app-config");
export const appConfigDb = getFirestore(appConfigApp);
